import { render, staticRenderFns } from "./FinancialTipsArticle3.vue?vue&type=template&id=890acf0a&scoped=true"
import script from "./FinancialTipsArticle3.vue?vue&type=script&lang=js"
export * from "./FinancialTipsArticle3.vue?vue&type=script&lang=js"
import style0 from "./FinancialTipsArticle3.vue?vue&type=style&index=0&id=890acf0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890acf0a",
  null
  
)

export default component.exports